/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/order */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/sort-comp */
/* eslint-disable arrow-body-style */
/* eslint-disable no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-disable react/self-closing-comp */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { createRef } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import './css/HotelDetails.css';
import { Helmet } from 'react-helmet';
import { pick, keys, xor, chunk } from 'lodash';
import { ThreeDots } from 'react-loader-spinner';
import {
  initToursSearch,
  getToursSearchStatus,
  getHotelToursSearchReustl,
  getHotelDetailsWithReviews,
  getHotelRooms,
  searchLong,
} from '../../Utils/RestUtils';
import {
  updateStateFromUrl,
  arrayToString,
  listOfObjectsWithIdToString,
  firstLetterInUpperCase,
  getHotelLocationName,
  getToursCount,
} from '../../Utils/CommonUtils';
import {
  changeDestination,
  changeDepartureDate,
  setNightsFrom,
  setNightsTo,
  setAdults,
  changeDepatureCity,
  changeSelectedResorts,
  setKids,
  changeHotelDetailsFilterMenuVisibility,
  changeCharterOnly,
  changeTouristsSearchText,
  changeDatesSearchText,
} from '../../DataStore/actions/searchFormActions';
import {
  changeHotelsFilter,
  changeStarsFilter,
  changeStarsFilterHover,
  changeMealsFilter,
  changeRatingFilter,
  changeBeachLineFilter,
  changeBeachTypesFilter,
  changeHotelTypeFilter,
  changeHotelServicesFilter,
  changeOnlyCharter,
  changeDirectFlight,
  changeCurrency,
  changeRegionsOptions,
  changeIsAllRegionsFilterTab,
  changeOperatorsFilter,
  changeIsAllOperatorsTab,
} from '../../DataStore/actions/FiltersAction';
import {
  HOTEL_DETAILS,
  ABOUT_HOTEL,
  HOTEL_MAP,
  REVIEWS,
  CHARTER_ONLY,
  DIRECT_FLIGHT,
  TOURS_NOT_FOUND,
  SYSTEM_FAULT,
  MAIN_PAGE,
  SLASH_DELIMITER,
  OTHER_PHOTO,
  PLACES_AVAILABILTY,
  FOR,
  ALL_MEAL_TYPES,
} from '../../Utils/Constants/GlobalConstants';
import SearchFormFunc from '../SearchForm/SearchFormFunc';
import { HOTEL_DETAILS_TITLE } from '../../Utils/Constants/SEO';
import {
  FROM_PARAM,
  TO_PARAM,
  DEPARTURE_FROM_PARAM,
  DEPARTURE_TO_PARAM,
  NIGHTS_FROM_PARAM,
  NIGHTS_TO_PARAM,
  ADULTS_PARAM,
  CURRENCY_PARAM,
  HOTEL_PARAM,
  MEALS_PARAM,
  OPERATORS_PARAM,
  CHARTER_ONLY_PARAM,
  DIRECT_PARAM,
  KIDS_PARAM,
  KIDS_AGES_PARAM,
} from '../../Utils/Constants/urlParams';
import { meals } from '../../Utils/Constants/Meals';
import { ReactComponent as OrangeStar } from '../../images/orange-star-r.svg';
import { ReactComponent as NoHotel } from '../../images/hotel-r.svg';
import DatesBar from './DatesBar/DatesBar';
import ProgressBar from '../ProgressBar/ProgressBar';
import { ReactComponent as ArrowDropdown } from '../../images/arrow-bottom-black-r.svg';
import { ReactComponent as ActiveCheck } from '../../images/active-check-r.svg';
import { ReactComponent as DefaultCheck } from '../../images/default-check-r.svg';
import ToursBar from './ToursBar/ToursBar';
import HotelPhotoSwiper from './HotelPhotoSwiper/HotelPhotoSwiper';
import { ReactComponent as HotelPicClose } from '../../images/hotel-pic-close-r.svg';
import { ReactComponent as RoomPlaceholder } from '../../images/room-placeholder.svg';
import DayMinPriceLoader from './DayMinPriceLoader/DayMinPriceLoader';
import GroupedByDateLoader from './GroupedByDateLoader/GroupedByDateLoader';
import HotelButtonsLoader from './HotelButtonsLoader/HotelButtonsLoader';
import NoResults from '../../images/no-results.png';
import HotelReviewsModal from '../Modals/HotelReviewsModal/HotelReviewsModal';
import AboutHotelModal from '../Modals/AboutHotelModal/AboutHotelModal';
import HotelMapModal from '../Modals/HotelMapModal/HotelMapModal';
import RoomDescriptionModal from '../Modals/RoomDescriptionModal/RoomDescriptionModal';
import CurrencySelector from '../CurrencySelector/CurrencySelector';
import { availableCurrencies } from '../../Utils/Constants/Currency';

const mapStateToProps = (state) => ({ ...state });

class HotelDetails extends React.Component {
  constructor(props) {
    super(props);

    this.fetchDataCounter = 0;
    this.reviewModalNode = React.createRef();
    this.reviewModaButtomNode = React.createRef();
    this.ablutHotelModalNode = React.createRef();
    this.roomDescriptionModalNode = React.createRef();
    this.ablutHotelButtomNode = React.createRef();
    this.hotelPicButtomNode = React.createRef();
    this.hotelPicModalNode = React.createRef();

    this.state = {
      loading: true,
      isHotelDetailsLoading: true,
      hotelDetails: {},
      dayMinPrice: [],
      groupedByDate: [],
      roomIds: [],
      roomsDescription: [],
      reviews: [],
      mealOptions: [],
      selectedMeal: ALL_MEAL_TYPES,
      selected: '',
      minPriceIndex: 0,
      progress: 0,
      isProgressVisible: false,
      idMealDropdowmVisible: false,
      isReviewsVisible: false,
      isAboutHotelVisible: false,
      isHotelMapVisible: false,
      isHotelPhotoVisible: false,
      selectedAboutHotelCategory: 0,
      isRoomDescriptionVisible: false,
      selectedRoomDescription: {},
      selectedRoomType: '',
      scrollbarWidth: 0,
      errorText: '',
      toursFound: 0,
    };
  }

  componentDidMount() {
    // screen withd
    this.timeout(500).then(() => {
      const scrollWidth =
        window.innerWidth - document.documentElement.clientWidth;

      this.setState({
        scrollbarWidth: scrollWidth,
      });
    });

    const mealOpt = meals.map((e) => ({
      id: e.id,
      name: `${e.russianfull} и лучше`,
    }));

    const mealsAll = [{ id: '0', name: 'Все типы питания' }].concat(mealOpt);

    this.setState({ mealOptions: mealsAll });

    const payload = updateStateFromUrl(this.props);

    this.fetchHotelDetails(payload[HOTEL_PARAM]);
    this.fetchData(payload, ++this.fetchDataCounter);
  }

  // modals add document listeners, they must not outlive the page
  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideMealClick, false);
    document.removeEventListener(
      'click',
      this.handleReviewModalOutsideClick,
      false,
    );
    document.removeEventListener(
      'click',
      this.handleAboutHotelModalOutsideClick,
      false,
    );
    document.removeEventListener(
      'click',
      this.handleHotelPicModalOutsideClick,
      false,
    );
    document.removeEventListener(
      'keydown',
      this.handleHotelPicModalEscPress,
      false,
    );
    document.removeEventListener(
      'click',
      this.handleRoomDescriptionModalOutsideClick,
      false,
    );
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  getPayloadFromState = () => {
    const {
      depatureCity,
      destination,
      departureDate,
      nightsFrom,
      nightsTo,
      adults,
      currency,
      mealsFilter,
      onlyCharter,
      directFlight,
      operatorsFilter,
      kids,
      hotelsFilter,
    } = this.props;

    const payload = {
      [FROM_PARAM]: depatureCity.id,
      [TO_PARAM]: destination.id,
      [DEPARTURE_FROM_PARAM]: moment(departureDate.from).format('YYYY-MM-DD'),
      [DEPARTURE_TO_PARAM]: moment(departureDate.to).format('YYYY-MM-DD'),
      [NIGHTS_FROM_PARAM]: nightsFrom,
      [NIGHTS_TO_PARAM]: nightsTo,
      [ADULTS_PARAM]: adults,
      [CURRENCY_PARAM]: currency.id,
    };

    if (hotelsFilter.length > 0) {
      payload[HOTEL_PARAM] = hotelsFilter[0].id;
    }

    if (kids.length > 0) {
      payload[KIDS_PARAM] = kids.length;
      payload[KIDS_AGES_PARAM] = arrayToString(kids.map((item) => item.age));
    }

    if (mealsFilter && mealsFilter.id) {
      payload[MEALS_PARAM] = mealsFilter.id;
    }

    if (onlyCharter === 1) {
      payload[CHARTER_ONLY_PARAM] = 1;
    }

    if (directFlight === 1) {
      payload[DIRECT_PARAM] = 1;
    }

    if (operatorsFilter.length > 0) {
      payload[OPERATORS_PARAM] = listOfObjectsWithIdToString(operatorsFilter);
    }

    return payload;
  };

  renderFilterQueryParam = (param, filter) => {
    const { navigate, location } = this.props;
    const queryParameters = new URLSearchParams(location.search);

    if (queryParameters.get(param)) {
      queryParameters.delete(param);
    }

    if (filter && filter.toString().length > 0) {
      queryParameters.append(param, filter);
    }

    navigate({
      pathname: '/hotel',
      search: queryParameters.toString(),
    });
  };

  fetchHotelDetails(hotelCode) {
    getHotelDetailsWithReviews(hotelCode)
      .then((response) => {
        if (response && response.data) {
          const details = response.data;

          let reviews = [];
          if (details && details.reviews && details.reviews.length > 0) {
            reviews = details.reviews.map((e, index) => {
              let short;
              let long;
              let isLong = false;

              if (e.content.length > 200) {
                short = e.content.substring(0, 200);
                // cut on word boundary
                const lastSpace = short.lastIndexOf(' ');
                if (lastSpace > 0) {
                  short = short.substring(0, lastSpace);
                }
                short += '...';
                long = e.content;
                isLong = true;
              } else {
                short = e.content;
              }

              return { ...e, short, long, isLong, showLong: false, id: index };
            });
          }

          this.setState({
            hotelDetails: details,
            reviews,
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ isHotelDetailsLoading: false });
      });
  }

  handleDateClick = (id) => {
    const { selected } = this.state;

    if (selected !== id) {
      this.setState({ selected: id });
    }
  };

  fetchForm = () => {
    this.setState({ dayMinPrice: [], groupedByDate: [] });

    this.fetchData(this.getPayloadFromState(), ++this.fetchDataCounter);
  };

  async timeout(delay) {
    return new Promise((res) => {
      setTimeout(res, delay);
    });
  }

  fillData(hotel) {
    const { groupedByDate, dayMinPrice } = hotel;

    let minPrice = dayMinPrice[0].dayMinPrice;
    let selected = 'date-0';
    let minPriceIndex = 0;

    dayMinPrice.forEach((dayPrice, index) => {
      if (minPrice > dayPrice.dayMinPrice) {
        minPrice = dayPrice.dayMinPrice;
        selected = `date-${index}`;
        minPriceIndex = index;
      }
    });

    const newGroupedByDate = [...groupedByDate];
    const roomIds = [];
    for (let i = 0; i < newGroupedByDate.length; i++) {
      const date = newGroupedByDate[i];
      const dateRooms = date.rooms;
      for (let j = 0; j < dateRooms.length; j++) {
        const room = dateRooms[j];
        room.ref = createRef();
        room.rightArrowVisible = false;
        room.leftArrowVisible = false;

        const roomNights = room.nights;
        for (let k = 0; k < roomNights.length; k++) {
          const nights = roomNights[k];
          nights.colluntNumber = k + 1;

          const { meals: mealss } = nights;

          for (let l = 0; l < mealss.length; l++) {
            const meal = mealss[l];
            meal.otherOffersVisible = false;
            meal.id = `${date.date}-${room.roomType}-${nights.nightsCount}-${meal.meal}`;

            meal.tours.forEach((tour) => {
              if (tour.roomId != 0 && !roomIds.includes(tour.roomId)) {
                roomIds.push(tour.roomId);
              }
            });
          }
        }
      }
    }

    const { roomIds: prevRoomIds } = this.state;
    const isRoomIdsChanged = xor(prevRoomIds, roomIds).length > 0;

    this.setState(
      {
        selected,
        minPriceIndex,
        dayMinPrice: [],
        groupedByDate: newGroupedByDate,
        roomIds,
      },
      () => {
        this.setState({ dayMinPrice });
        if (isRoomIdsChanged) {
          this.fetchRoomsDescription(roomIds);
        }
      },
    );
  }

  fetchRoomsDescription(roomIds) {
    if (roomIds.length === 0) {
      return;
    }

    const local = this.fetchDataCounter;
    // tourvisor accepts up to 30 ids per request
    const requests = chunk(roomIds, 30).map((ids) => getHotelRooms(ids));

    Promise.all(requests)
      .then((responses) => {
        if (local === this.fetchDataCounter) {
          const roomsDescription = [];
          responses.forEach((response) => {
            if (response && response.data) {
              roomsDescription.push(...response.data);
            }
          });

          this.setState({ roomsDescription });
        }
      })
      .catch(() => {});
  }

  getRoomDescription = (room) => {
    const { roomsDescription } = this.state;
    let result;

    room.nights.forEach((nights) => {
      nights.meals.forEach((meal) => {
        meal.tours.forEach((tour) => {
          if (!result && tour.roomId != 0) {
            result = roomsDescription.find(
              (description) => description.id == tour.roomId,
            );
          }
        });
      });
    });

    return result;
  };

  renderRoomType = (room) => {
    const roomDescription = this.getRoomDescription(room);
    const roomType = firstLetterInUpperCase(room.roomType);

    const placeholder = (
      <div className="hd_room_type_placeholder">
        <RoomPlaceholder />
      </div>
    );

    if (!roomDescription) {
      return (
        <div>
          {roomType}
          {placeholder}
        </div>
      );
    }

    const { images } = roomDescription;
    const openModal = () => {
      this.handleRoomDescriptionModalClick(roomDescription, roomType);
    };

    return (
      <div className="hd_room_type_w">
        <button type="button" className="hd_room_type_link" onClick={openModal}>
          {roomType}
        </button>
        <button
          type="button"
          className="hd_room_type_pic_but"
          onClick={openModal}
        >
          {images && images.length > 0 ? (
            <img
              alt=""
              className="hd_room_type_pic"
              src={`https:${images[0].replace(/^https?:/, '')}`}
            />
          ) : (
            placeholder
          )}
        </button>
      </div>
    );
  };

  renderDayTours = (dates) =>
    dates.map((date, index) => {
      const id = `date-${index}`;
      const { selected } = this.state;
      return (
        <div key={`room-${id}`}>
          {selected === id && (
            <div className="offer_details_selected">
              {this.renderDayRooms(date.date, date.rooms)}
            </div>
          )}
        </div>
      );
    });

  renderDayRooms = (date, rooms) =>
    rooms.map((room, index) => {
      const { groupedByDate } = this.state;
      const { otherToursCoords } = this.props;
      const { top, left } = otherToursCoords;
      const roomRef = createRef();

      return (
        <div
          key={`room-w-${date}-${index}`}
          className="hd_room_container"
          ref={(node) => {
            roomRef.current = node;
          }}
        >
          <div className="hd_day_room_w">
            <div className="hd_room_type">{this.renderRoomType(room)}</div>
            <div className="hd_nights_w">
              <ToursBar
                date={date}
                room={room}
                groupedByDate={groupedByDate}
                setGroupedByDate={(newState) => {
                  this.setState({ groupedByDate: newState });
                }}
                roomRef={roomRef}
              />
            </div>
          </div>
          <div
            className={`tb_other tb_other_${date}_${room.roomType.replace(
              ' ',
              '_',
            )}`}
            style={{ top, left }}
          ></div>
        </div>
      );
    });

  getTimeout = (cout) => {
    let result;
    if (cout <= 3) {
      result = 2000;
    } else if (cout <= 5) {
      result = 3000;
    } else {
      result = 5000;
    }

    return result;
  };

  async fetchData(payload, fetchDataCounter, currentRequestId, isMoreSearch) {
    this.setState({
      errorText: '',
      isProgressVisible: true,
    });
    let localProgress = 0;

    if (isMoreSearch) {
      this.setState({ progress: 70 });
      localProgress = 70;
    } else {
      this.setState({
        progress: 0,
        loading: true,
        toursFound: 0,
        roomIds: [],
        roomsDescription: [],
      });
    }

    let isError = false;

    const localFetchDataCounter = fetchDataCounter;

    let requestId;

    if (currentRequestId) {
      requestId = currentRequestId;
    } else {
      const requestIdResponse = await initToursSearch(payload).catch(() => {
        isError = true;
        this.setState({
          errorText: SYSTEM_FAULT,
        });
      });

      if (!isError && requestIdResponse && requestIdResponse.data) {
        const { searchId } = requestIdResponse.data;
        requestId = searchId;
      }
    }

    if (!isError && requestId) {
      const counterLimit = 30;
      let counter = 0;
      let searchProcess = 0;
      let completedCount = 0;

      while (
        searchProcess !== 100 &&
        counter < counterLimit &&
        localFetchDataCounter === this.fetchDataCounter
      ) {
        isError = false;
        counter++;
        await this.timeout(this.getTimeout(counter));

        // check request id
        const statusResponse = await getToursSearchStatus(requestId).catch(
          () => {
            isError = true;
          },
        );

        if (
          !isError &&
          statusResponse &&
          statusResponse.data &&
          localFetchDataCounter === this.fetchDataCounter
        ) {
          const { operatorStatus, progress } = statusResponse.data;
          searchProcess = progress;

          const newCompletedCount = operatorStatus.filter(
            (e) => e.status === 'complete',
          ).length;

          if (searchProcess > localProgress) {
            localProgress = searchProcess;
            this.setState({ progress: localProgress });
          } else if (localProgress < 90) {
            localProgress += 3;
            this.setState({ progress: localProgress });
          }

          if (newCompletedCount > completedCount && requestId != 0) {
            completedCount = newCompletedCount;

            const toursResult = await getHotelToursSearchReustl(
              requestId,
            ).catch(() => {
              isError = true;

              if (completedCount === 0) {
                this.setState({ errorText: SYSTEM_FAULT, loading: false });
              }
            });

            if (
              !isError &&
              toursResult &&
              toursResult.data &&
              localFetchDataCounter === this.fetchDataCounter
            ) {
              const { toursCount } = toursResult.data;

              this.fillData(toursResult.data);

              this.setState({
                loading: false,
                toursFound: toursCount,
              });
            }
          }
        }
      }

      // outdated search, a newer one is already running
      if (localFetchDataCounter !== this.fetchDataCounter) {
        return;
      }

      if (searchProcess === 100 && !isMoreSearch) {
        const searchMoreResponse = await searchLong(requestId);

        if (
          searchMoreResponse &&
          searchMoreResponse.data &&
          localFetchDataCounter === this.fetchDataCounter
        ) {
          const { requestCount } = searchMoreResponse.data;

          if (requestCount !== 0) {
            this.fetchData(payload, ++this.fetchDataCounter, requestId, true);
          } else {
            // stop search
            if (searchProcess === 100 || counter === counterLimit) {
              this.setState({ progress: 100 });

              this.timeout(1000).then(() => {
                this.setState({ isProgressVisible: false });
              });
            }

            // handle empty result
            const { groupedByDate } = this.state;
            if (groupedByDate.length === 0) {
              this.setState({
                errorText: TOURS_NOT_FOUND,
                loading: false,
              });
            }
          }
        }
      } else {
        // stop search
        if (searchProcess === 100 || counter === counterLimit) {
          this.setState({ progress: 100 });

          this.timeout(1000).then(() => {
            this.setState({ isProgressVisible: false });
          });
        }

        // handle empty result
        const { groupedByDate } = this.state;
        if (groupedByDate.length === 0) {
          this.setState({
            errorText: TOURS_NOT_FOUND,
            loading: false,
          });
        }
      }
    }
  }

  handleDropdown = (meal) => {
    this.handleMealClick();
    this.setState({ selectedMeal: meal.name });

    const { changeMealsFilter: changeMealsFilterAction, mealsFilter } =
      this.props;

    if (mealsFilter.id != meal.id) {
      this.setState({
        groupedByDate: [],
        dayMinPrice: [],
      });

      let payload;
      if (meal.id == 0) {
        changeMealsFilterAction({});
        this.renderFilterQueryParam(MEALS_PARAM);
        payload = this.getPayloadFromState();
        payload = pick(
          payload,
          keys(payload).filter((key) => key !== MEALS_PARAM),
        );
      } else {
        const filteredMeal = meals.filter((e) => e.id === meal.id)[0];
        changeMealsFilterAction(filteredMeal);
        this.renderFilterQueryParam(MEALS_PARAM, filteredMeal.id);
        payload = this.getPayloadFromState();
        payload[MEALS_PARAM] = filteredMeal.id;
      }

      this.fetchData(payload, ++this.fetchDataCounter);
    }
  };

  handleCharterFilter = () => {
    const { onlyCharter, changeOnlyCharter: changeOnlyCharterAction } =
      this.props;

    this.setState({ dayMinPrice: [], groupedByDate: [] });

    let payload;
    if (onlyCharter === 1) {
      changeOnlyCharterAction(0);
      this.renderFilterQueryParam(CHARTER_ONLY_PARAM);
      payload = this.getPayloadFromState();
      payload = pick(
        payload,
        keys(payload).filter((key) => key !== CHARTER_ONLY_PARAM),
      );
    } else {
      changeOnlyCharterAction(1);
      this.renderFilterQueryParam(CHARTER_ONLY_PARAM, 1);
      payload = this.getPayloadFromState();
      payload[CHARTER_ONLY_PARAM] = 1;
    }

    this.fetchData(payload, ++this.fetchDataCounter);
  };

  handleDirectFilter = () => {
    const { directFlight, changeDirectFlight: changeDirectFlightAction } =
      this.props;

    this.setState({ dayMinPrice: [], groupedByDate: [] });

    let payload;
    if (directFlight === 1) {
      changeDirectFlightAction(0);
      this.renderFilterQueryParam(DIRECT_PARAM);
      payload = this.getPayloadFromState();
      payload = pick(
        payload,
        keys(payload).filter((key) => key !== DIRECT_PARAM),
      );
    } else {
      changeDirectFlightAction(1);
      this.renderFilterQueryParam(DIRECT_PARAM, 1);
      payload = this.getPayloadFromState();
      payload[DIRECT_PARAM] = 1;
    }

    this.fetchData(payload, ++this.fetchDataCounter);
  };

  renderHotelCategory = (starsCount) => {
    const content = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < starsCount; i++) {
      content.push(<OrangeStar key={`star-${i}`} className="hd_star_ico" />);
    }
    return content;
  };

  getHotelImageStyle = (hotelDescription, index) => {
    let backgroundImage = {};

    if (
      hotelDescription &&
      hotelDescription.images &&
      hotelDescription.images.length > 0
    ) {
      const url = `https:${hotelDescription.images[index]}`;

      backgroundImage = {
        backgroundImage: `url("${url}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      };
    }

    return backgroundImage;
  };

  handleMealClick = () => {
    const { idMealDropdowmVisible } = this.state;
    if (!idMealDropdowmVisible) {
      document.addEventListener('click', this.handleOutsideMealClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideMealClick, false);
    }

    this.setState({ idMealDropdowmVisible: !idMealDropdowmVisible });
  };

  handleOutsideMealClick = (e) => {
    if (this.mealDropdowmNode.contains(e.target)) {
      return;
    }

    this.handleMealClick();
  };

  handleHotelMapModalClick = () => {
    const { isHotelMapVisible, scrollbarWidth } = this.state;

    if (!isHotelMapVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    this.setState({ isHotelMapVisible: !isHotelMapVisible });
  };

  handleReviewModalClick = () => {
    const { isReviewsVisible, reviews, scrollbarWidth } = this.state;
    const newReviewState = reviews.map((e) => ({ ...e, showLong: false }));

    if (!isReviewsVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleReviewModalOutsideClick,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleReviewModalOutsideClick,
        false,
      );
    }

    this.setState({
      isReviewsVisible: !isReviewsVisible,
      reviews: newReviewState,
    });
  };

  handleReviewModalOutsideClick = (e) => {
    const className = e.target.className;
    const isSVG =
      e.target.getAttribute('viewBox') !== null ||
      e.target.getAttribute('fill');
    if (
      this.reviewModaButtomNode.current.contains(e.target) ||
      this.reviewModalNode.current.contains(e.target) ||
      className === 'hotel_rev_ream_more dbr_text_16' ||
      isSVG
    ) {
      return;
    }

    this.handleReviewModalClick();
  };

  handleAboutHotelModalClick = () => {
    const { isAboutHotelVisible, reviews, scrollbarWidth } = this.state;
    const newReviewState = reviews.map((e) => ({ ...e, showLong: false }));

    if (!isAboutHotelVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleAboutHotelModalOutsideClick,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleAboutHotelModalOutsideClick,
        false,
      );
    }

    this.setState({
      isAboutHotelVisible: !isAboutHotelVisible,
      reviews: newReviewState,
    });
  };

  handleAboutHotelModalOutsideClick = (e) => {
    if (
      this.ablutHotelButtomNode.current.contains(e.target) ||
      this.ablutHotelModalNode.current.contains(e.target)
    ) {
      return;
    }

    this.handleAboutHotelModalClick();
  };

  handleHotelPicModalClick = () => {
    const { isHotelPhotoVisible, scrollbarWidth } = this.state;

    if (!isHotelPhotoVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleHotelPicModalOutsideClick,
        false,
      );
      document.addEventListener(
        'keydown',
        this.handleHotelPicModalEscPress,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleHotelPicModalOutsideClick,
        false,
      );
      document.removeEventListener(
        'keydown',
        this.handleHotelPicModalEscPress,
        false,
      );
    }

    this.setState({
      isHotelPhotoVisible: !isHotelPhotoVisible,
    });
  };

  handleHotelPicModalEscPress = (e) => {
    if (e.key === 'Escape') {
      this.handleHotelPicModalClick();
    }
  };

  handleHotelPicModalOutsideClick = (e) => {
    const className = e.target.className;
    const isSVG =
      e.target.getAttribute('viewBox') !== null ||
      e.target.getAttribute('fill');
    if (
      this.hotelPicButtomNode.current.contains(e.target) ||
      this.hotelPicModalNode.current.contains(e.target) ||
      className === 'hd_ream_more dbr_text_16' ||
      isSVG
    ) {
      return;
    }

    this.handleHotelPicModalClick();
  };

  handleRoomDescriptionModalClick = (roomDescription, roomType) => {
    const { isRoomDescriptionVisible, scrollbarWidth } = this.state;

    if (!isRoomDescriptionVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleRoomDescriptionModalOutsideClick,
        false,
      );

      this.setState({
        isRoomDescriptionVisible: true,
        selectedRoomDescription: roomDescription,
        selectedRoomType: roomType,
      });
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleRoomDescriptionModalOutsideClick,
        false,
      );

      this.setState({ isRoomDescriptionVisible: false });
    }
  };

  handleRoomDescriptionModalOutsideClick = (e) => {
    const isSVG =
      e.target.getAttribute('viewBox') !== null ||
      e.target.getAttribute('fill');
    const modalNode = this.roomDescriptionModalNode.current;

    if (
      !modalNode ||
      e.target.closest('.hd_room_type_w') ||
      modalNode.contains(e.target) ||
      isSVG
    ) {
      return;
    }

    this.handleRoomDescriptionModalClick();
  };

  isToursCountVisible = () => {
    const { loading, toursFound } = this.state;

    return !loading && toursFound > 0;
  };

  handleCurrencyClick = (value) => {
    const { currency, changeCurrency: changeCurrencyAction } = this.props;

    if (currency.id !== value) {
      const newCurr = availableCurrencies.filter((e) => e.id === value)[0];

      changeCurrencyAction(newCurr);

      const payload = this.getPayloadFromState();
      payload[CURRENCY_PARAM] = value;
      this.renderFilterQueryParam(CURRENCY_PARAM, value.toString());

      this.fetchData(payload, ++this.fetchDataCounter);
    }
  };

  render() {
    const {
      dayMinPrice,
      groupedByDate,
      reviews,
      mealOptions,
      errorText,
      hotelDetails,
      loading,
      progress,
      isProgressVisible,
      selected,
      selectedMeal,
      idMealDropdowmVisible,
      minPriceIndex,
      isReviewsVisible,
      isAboutHotelVisible,
      isHotelMapVisible,
      isHotelDetailsLoading,
      selectedAboutHotelCategory,
      isHotelPhotoVisible,
      toursFound,
      isRoomDescriptionVisible,
      selectedRoomDescription,
      selectedRoomType,
    } = this.state;

    const {
      onlyCharter,
      directFlight,
      destination,
      touristsSearchText,
      datesSearchText,
    } = this.props;

    return (
      <div>
        <Helmet>
          <title>{`${HOTEL_DETAILS_TITLE} ${
            hotelDetails.name ? hotelDetails.name : ''
          }`}</title>
        </Helmet>

        <div className="containerW">
          <div className="content">
            <div className="hd_breadcrumbs gm_text_14">
              {hotelDetails && (
                <div className="hd_breadcrumbs_link_line">
                  <Link className="gm_text_14" to="/">
                    {MAIN_PAGE}
                  </Link>
                  <div className="hd_breadcrumb_delimiter">
                    {SLASH_DELIMITER}
                  </div>
                  <Link className="gm_text_14" to="/uae">
                    {destination.name}
                  </Link>
                  <div className="hd_breadcrumb_delimiter">
                    {SLASH_DELIMITER}
                  </div>
                  <div className="hd_title">
                    {firstLetterInUpperCase(hotelDetails.name)}
                  </div>
                </div>
              )}
            </div>
            <div className="hd_title_line">
              <div className="hd_title_collumn1">
                <div>{this.renderHotelCategory(hotelDetails.stars)}</div>
                <div className="hd_hotel_title">
                  {firstLetterInUpperCase(hotelDetails.name)}
                </div>
                <div className="gr_text_14 mb_20">
                  {getHotelLocationName(hotelDetails)}
                </div>
              </div>
              <div className="hd_title_collumn2">
                {isHotelDetailsLoading ? (
                  <HotelButtonsLoader />
                ) : (
                  <>
                    {hotelDetails.name && (
                      <button
                        ref={(node) => {
                          this.ablutHotelButtomNode.current = node;
                        }}
                        type="button"
                        className="hd_hotel_title_but gray_button"
                        onClick={this.handleAboutHotelModalClick}
                      >
                        {ABOUT_HOTEL}
                      </button>
                    )}
                    {hotelDetails.coord1 && hotelDetails.coord2 && (
                      <button
                        type="button"
                        className="hd_hotel_title_but gray_button"
                        onClick={this.handleHotelMapModalClick}
                      >
                        {HOTEL_MAP}
                      </button>
                    )}
                    {reviews.length > 0 && (
                      <button
                        ref={(node) => {
                          this.reviewModaButtomNode.current = node;
                        }}
                        type="button"
                        className="hd_hotel_title_but gray_button"
                        onClick={this.handleReviewModalClick}
                      >
                        {REVIEWS}
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="hd_hotel_img_w">
              <div className="hd_hotel_img_col1 hd_hotel_img_item">
                <NoHotel />
                <div
                  className="hd_hotel_img_col1_img hd_hotel_img_col_img"
                  style={this.getHotelImageStyle(hotelDetails, 0)}
                ></div>
              </div>
              <div className="hd_hotel_img_col2_w">
                <div className="hd_hotel_img_col2_img hd_hotel_img_item">
                  <NoHotel />
                  <div
                    className="hd_hotel_img_col2_img hd_hotel_img_col_img"
                    style={this.getHotelImageStyle(hotelDetails, 1)}
                  ></div>
                </div>
                <div className="hd_hotel_img_col2_img hd_hotel_img_item">
                  <NoHotel />
                  <div
                    className="hd_hotel_img_col2_img hd_hotel_img_col_img"
                    style={this.getHotelImageStyle(hotelDetails, 2)}
                  >
                    <button
                      ref={(node) => {
                        this.hotelPicButtomNode.current = node;
                      }}
                      type="button"
                      className="hd_other_photo"
                      onClick={this.handleHotelPicModalClick}
                    >
                      {OTHER_PHOTO}
                    </button>
                  </div>
                </div>
              </div>
              <div className="hd_hotel_img_col3 hd_hotel_img_item">
                <NoHotel />
                <div
                  className="hd_hotel_img_col1_img hd_hotel_img_col_img"
                  style={this.getHotelImageStyle(hotelDetails, 3)}
                ></div>
              </div>
            </div>

            <div className="hd_availability_title">{`${PLACES_AVAILABILTY} ${datesSearchText} ${FOR} ${touristsSearchText}`}</div>

            <div className="hd_dates_bar_w">
              <div className="">
                <SearchFormFunc
                  page={HOTEL_DETAILS}
                  search={this.fetchForm}
                  hotel={hotelDetails.name ? hotelDetails.name : ''}
                />
              </div>
              <div className="hd_progress_w">
                {isProgressVisible && <ProgressBar progress={progress} />}
              </div>
              <div className="hd_dates_w">
                {loading ? (
                  <DayMinPriceLoader />
                ) : (
                  <DatesBar
                    dates={dayMinPrice}
                    handleDateClick={this.handleDateClick}
                    selected={selected}
                    minPriceIndex={minPriceIndex}
                  />
                )}
              </div>
            </div>

            <div className="hd_line">
              <div className="hd_filter_line">
                <div
                  className="hd_meal_dropdowm_w"
                  ref={(node) => {
                    this.mealDropdowmNode = node;
                  }}
                >
                  <button
                    type="button"
                    className="hd_meal_dropdown"
                    onClick={this.handleMealClick}
                  >
                    <div className="br_text_16">{selectedMeal}</div>
                    <ArrowDropdown />
                  </button>
                  {idMealDropdowmVisible && (
                    <div className="hd_meal_options_w">
                      {mealOptions.map((meal) => (
                        <button
                          key={meal.name}
                          type="button"
                          className="meal_drop_but"
                          onClick={() => this.handleDropdown(meal)}
                        >
                          {meal.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  type="button"
                  onClick={this.handleCharterFilter}
                  className="hd_filter_button"
                >
                  {onlyCharter === 1 ? (
                    <ActiveCheck className="hd_charter_check" />
                  ) : (
                    <DefaultCheck className="hd_charter_check" />
                  )}
                  <div className="br_text_16">{CHARTER_ONLY}</div>
                </button>

                <button
                  type="button"
                  onClick={this.handleDirectFilter}
                  className="hd_filter_button"
                >
                  {directFlight === 1 ? (
                    <ActiveCheck className="hd_charter_check" />
                  ) : (
                    <DefaultCheck className="hd_charter_check" />
                  )}
                  <div className="br_text_16">{DIRECT_FLIGHT}</div>
                </button>
              </div>

              <CurrencySelector handleCurrency={this.handleCurrencyClick} />
            </div>

            <div className="hd_tours_found_w">
              {this.isToursCountVisible() > 0 && (
                <div className="hd_tours_found">
                  <div className="bm_text_18">{getToursCount(toursFound)}</div>

                  <div className="hd_three_dots_w">
                    <ThreeDots
                      visible={isProgressVisible}
                      height="30"
                      width="30"
                      color="rgba(0, 0, 0, .3)"
                      radius="5"
                      ariaLabel="three-dots-loading"
                      wrapperClass="hd_three_dots"
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="hd_offers_wrapper">
              {errorText.length > 0 && (
                <div className="hd_not_found_w">
                  <div className="hd_not_found">
                    <img src={NoResults} alt="" className="mb_5" />
                    <div className="br_text_18">{errorText}</div>
                  </div>
                </div>
              )}

              {loading ? (
                <GroupedByDateLoader />
              ) : (
                <div>{this.renderDayTours(groupedByDate)}</div>
              )}
            </div>
            <div className="hd_tours_w">
              <div className="hd_tours_col1"></div>
            </div>
          </div>
        </div>

        {/* hotel photo modal */}
        <div
          className={`hd_modal_container hd_photo_modal_container ${
            isHotelPhotoVisible ? 'hd_modal_open' : ''
          }`}
        >
          <div
            className="hd_hotel_pic_modal"
            ref={(node) => {
              this.hotelPicModalNode.current = node;
            }}
          >
            {hotelDetails.images && (
              <HotelPhotoSwiper images={hotelDetails.images} />
            )}
          </div>
          <button
            className="hd_hotel_photo_close"
            type="button"
            onClick={this.handleHotelPicModalClick}
          >
            <HotelPicClose />
          </button>
        </div>

        <HotelReviewsModal
          isVisible={isReviewsVisible}
          reviewModalNode={this.reviewModalNode}
          handleReviewModalClick={this.handleReviewModalClick}
          reviews={reviews}
          setReviewsState={(e) => {
            this.setState({ reviews: e });
          }}
        />

        <HotelMapModal
          isVisible={isHotelMapVisible}
          handleModalClick={this.handleHotelMapModalClick}
          hotelDetails={hotelDetails}
        />

        <AboutHotelModal
          isVisible={isAboutHotelVisible}
          modalNode={this.ablutHotelModalNode}
          handleModalClick={this.handleAboutHotelModalClick}
          hotelDetails={hotelDetails}
          selectedCategory={selectedAboutHotelCategory}
          setSelectedCategory={(category) => {
            this.setState({ selectedAboutHotelCategory: category });
          }}
        />

        <RoomDescriptionModal
          isVisible={isRoomDescriptionVisible}
          modalNode={this.roomDescriptionModalNode}
          handleModalClick={this.handleRoomDescriptionModalClick}
          roomDescription={selectedRoomDescription}
          roomType={selectedRoomType}
        />
      </div>
    );
  }
}

HotelDetails.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  kids: PropTypes.instanceOf(Array).isRequired,
  depatureCity: PropTypes.instanceOf(Object).isRequired,
  destination: PropTypes.instanceOf(Object).isRequired,
  departureDate: PropTypes.instanceOf(Object).isRequired,
  nightsFrom: PropTypes.number.isRequired,
  nightsTo: PropTypes.number.isRequired,
  adults: PropTypes.number.isRequired,
  navigate: PropTypes.func.isRequired,
  changeOnlyCharter: PropTypes.func.isRequired,
  currency: PropTypes.instanceOf(Object).isRequired,
  mealsFilter: PropTypes.instanceOf(Object).isRequired,
  operatorsFilter: PropTypes.instanceOf(Array).isRequired,
  onlyCharter: PropTypes.number.isRequired,
  directFlight: PropTypes.number.isRequired,
  changeDirectFlight: PropTypes.func.isRequired,
  changeMealsFilter: PropTypes.func.isRequired,
  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
  otherToursCoords: PropTypes.instanceOf(Object).isRequired,
  touristsSearchText: PropTypes.string.isRequired,
  datesSearchText: PropTypes.string.isRequired,
  changeCurrency: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeDestination,
  changeDepartureDate,
  setNightsFrom,
  setNightsTo,
  setAdults,
  setKids,
  changeDepatureCity,
  changeSelectedResorts,
  changeHotelDetailsFilterMenuVisibility,
  changeCharterOnly,

  changeHotelsFilter,
  changeStarsFilter,
  changeStarsFilterHover,
  changeMealsFilter,
  changeRatingFilter,
  changeBeachLineFilter,
  changeBeachTypesFilter,
  changeHotelTypeFilter,
  changeHotelServicesFilter,
  changeOnlyCharter,
  changeDirectFlight,
  changeCurrency,
  changeRegionsOptions,
  changeIsAllRegionsFilterTab,
  changeOperatorsFilter,
  changeIsAllOperatorsTab,
  changeTouristsSearchText,
  changeDatesSearchText,
})(HotelDetails);
